/**
 * Which attribute of the source record an Account Group Rule matches on. Mirrors the RuleType
 * enum in RightsLine.Data.AccountingProcesses.Models -- keep the values in sync.
 *
 * Independent of the rule's RuleSource: an Amount rule is always FieldValue, while a Catalog
 * rule can be any of the four.
 */
export enum RuleType {
	FieldValue = 1,
	Record = 2,
	Template = 3,
	TemplateGroup = 4
}